
import { EmptyValue } from '../InterpreterValue';
import { FunctionArgumentType, FunctionPlugin } from './FunctionPlugin';
/**
 * Interpreter plugin containing MEDIAN function
 */
export class CountBlankPlugin extends FunctionPlugin {
    countblank(ast, state) {
        return this.runFunction(ast.args, state, this.metadata('COUNTBLANK'), (...args) => {
            let counter = 0;
            args.forEach((arg) => {
                if (arg === EmptyValue) {
                    counter++;
                }
            });
            return counter;
        });
    }
}
CountBlankPlugin.implementedFunctions = {
    'COUNTBLANK': {
        method: 'countblank',
        parameters: [
            { argumentType: FunctionArgumentType.SCALAR }
        ],
        repeatLastArgs: 1,
        expandRanges: true,
    },
};
